// Chakra imports
import { Box, SimpleGrid } from "@chakra-ui/react";

// Custom components
import ExerciseList from "./components/ExerciseList";
import ExerciseStats from "./components/ExerciseStats";

export default function Exercises() {
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <SimpleGrid columns={{ base: 1, md: 1, xl: 1 }} gap="20px" mb="20px">
                <ExerciseStats />
                <ExerciseList />
            </SimpleGrid>
        </Box>
    );
}
